<template>
  <div class="parent-box">
    <modal-main v-if="showModal" @close="showModal = false">
      <h4 slot="header">
        Search Customers
      </h4>
      <div slot="body" style="width: 100%;">
        <form>
          <select class="form-control">
            <option>Select</option>
            <option>Account</option>
            <option>Transaction Ref</option>
            <option>Al Customers</option>
            <option>Successful Onboarded</option>
          </select>
        </form>
        <div class="pt-4 text-right">
              <button type="button" @click="showModal = true" class="btn btn-warning btn-sm">Search</button>
        </div>
      </div>
    </modal-main>



    <!-- step 1 -->
    <div class="container">
    <div class="">
          <h2 class="page-header">Customer Onboarding</h2>

    </div>
    <div class="text-right">
              <button type="button" @click="showModal = true" class="btn btn-warning btn-sm">Search</button>
              </div>

      <div>
        <table class="table table-bordered">
          <br />
          <br />

          <tr>
            <th class="text-nowrap mr-5">Name</th>
            <th class="text-nowrap mr-5 go-right text-left pr-5">
              Nuban
            </th>
            <th class="text-nowrap mr-5 go-righty" style="margin-right: 60px;">
              Account Category
            </th>
            <th class="text-nowrap mr-5 go-righty text-left">
              Account Type
            </th>

            <th class="text-nowrap mr-5 go-righty text-left">
              Ticket Number
            </th>
            <th class="text-nowrap">Available Balance</th>
            <th class="text-nowrap">Tenor</th>
            <th class="text-nowrap">Customer Status</th>
          </tr>
          <tr v-for="item in datas" :key="item.id">
            <td class="mr-5 text-nowrap text-center">
              {{ item.name }}
            </td>
            <td class="mr-5 text-nowrap text-center">
              {{ item.nuban }}
            </td>
            <td class="mr-5 text-nowrap text-center">
              {{ item.accountCategory }}
            </td>
            <td class="mr-5 text-nowrap text-center">
              {{ item.accountType.slice(0, 11) }}
            </td>

            <td class="mr-5 text-nowrap">
              {{ item.ticketNo }}
            </td>
            <td class="mr-5 text-nowrap">
              {{ item.availableBal }}
            </td>
            <td class="mr-5 text-nowrap">
              {{ item.tenor }}
            </td>
            <td class="mr-5 text-nowrap">
              {{ item.status }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="footer">
      <!-- real footer item -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import ModalMain from "./Modal";

export default {
  name: "FinishTab",
  props: {
    getUserSession: null,
  },
  components: {
    ModalMain,
  },
  computed: {},
  data() {
    return {
      default: false,
      showModal: true,
      showEdit: false,
      form: {
        bvn: "",
      },
      datas: [],
      formErrors: {},
      // activeIndex: 0,
      summary: {},
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    },
    getCustomers() {
      axios
        .get(
          `https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/customerAccountDetails`
        )
        .then((res) => {
          this.datas = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    edit(){
      this.showEdit = true;
    }
  },
  async mounted() {
    this.getCustomers();
  },
};
</script>

<style lang="scss" scoped>
.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 6px;
  border: 0;
  margin-right:15px;
  background-color:#ffb946;
  font-weight: bold;

  &:hover {
    background-color: #ffb946;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/customer-admin/Customer.vue